import { useState } from "react";
import { Search } from "lucide-react";

interface SearchBarProps {
  onSearch: (searchTerm: string) => void;
  placeholder?: string;
}

const SearchBar = ({ onSearch, placeholder = "Search for hacks..." }: SearchBarProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <div className="relative">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder}
          className="w-full py-3 px-10 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-hackGreen-300 shadow-sm"
          style={{ fontFamily: 'Manrope, sans-serif' }}
        />
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
      </div>
      <button 
        type="submit" 
        className="absolute right-0 top-0 h-full px-4 sm:px-6 bg-black text-white rounded-r-md hover:bg-gray-800 transition-all font-medium"
        style={{ fontFamily: 'Manrope, sans-serif' }}
      >
        Search
      </button>
    </form>
  );
};

export default SearchBar;
